import { useTheme } from "next-themes";
import { createPortal } from "react-dom";
import { componentsList } from "../../lib/widgetComponentsDir";
import { closeLg } from "../icons/SVGIcons";
import { Button } from "./Button";
interface IModal {
  setModalOpen: (_arg: boolean) => void;
  toLoad: string;
  closeOnClick: boolean;
  closeButtonIcon?: any;
  heading: string;
  modalWidth?: string;
  modalHeight?: string;
  modalClassName?: string;
  id: string;
}

const Modal = ({
  setModalOpen,
  toLoad,
  closeOnClick,
  closeButtonIcon,
  heading,
  modalWidth,
  modalHeight,
  modalClassName,
  id,
}: IModal) => {
  function handleBackgroundClick(isCloseModalButton: boolean) {
    if (closeOnClick || isCloseModalButton) {
      setModalOpen(false);
    }
  }
  const { theme } = useTheme();

  const WidgetToLoadAsExpanded = componentsList[toLoad];

  // wrapping the return in a hidden div means it will never alter the DOM where it is loaded.
  return (
    <div className="hidden">
      {createPortal(
        <div
          id="modalBackground"
          className="absolute top-0 z-40 flex h-screen w-full"
          style={{ backgroundColor: "rgb(203, 213, 225, 0.2)" }}
          onClick={() => handleBackgroundClick(false)}
        >
          <div className="flex h-full w-full items-center justify-center ">
            <div
              className={`max-w-[1300px] rounded-2xl border border-gray-300 bg-cubeBase-500 text-black dark:border-transparent dark:bg-cubeBaseDark-500 dark:text-white ${modalClassName ?? ""}`}
              style={{ height: modalHeight, width: modalWidth }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex h-full  flex-col	 items-center justify-between rounded-xl  drop-shadow-lg">
                <div
                  id={`${heading}Header`}
                  className="flex	 h-9 w-full flex-row items-center justify-between rounded-t-xl  border-b border-gray-600 bg-cubeBase-800 px-3 text-black dark:bg-cubeBaseDark-900 dark:text-white"
                >
                  <div id="title" className="text-md overflow-hidden pl-3 ">
                    {heading}
                  </div>
                  <div>
                    <Button
                      variant="exit"
                      id="closeModal"
                      onClick={() => handleBackgroundClick(true)}
                    >
                      {closeButtonIcon ? closeButtonIcon : closeLg}
                    </Button>
                  </div>
                </div>
                <div
                  className={`h-full w-full overflow-auto rounded-b-2xl ${theme != "dark" ? "minimalScrollBar" : "minimalScrollBarDark"} `}
                >
                  {<WidgetToLoadAsExpanded cryptoID={id} />}
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.getElementById("modal") as HTMLElement,
      )}
    </div>
  );
};

export default Modal;
